import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import { getInputField, getSelectField } from '../subscriptor/forms/fields';
import { maintainerForm as styles } from '../maintainer/styles';
import {
  COMMUNE_MAX_LENGTH_CODE,
  COMMUNE_MAX_LENGTH_NAME,
  COMMUNE_LENGTH_PROVINCE,
  COMMUNE_EFX_MAX_LENGTH_NAME,
  REGION_MAX_LENGTH_NAME
} from '../../libraries/constants';
import { allowNumeric } from '../../libraries/validators';
import RegionService from '../../services/region-service';
import { maximumSubString } from '../../libraries/utils';

const form = props => {
  const {
    values,
    classes,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    title,
    setFieldTouched
  } = props;
  const [regions, setRegions] = useState([]);

  const fieldProps = {
    handleBlur,
    classes,
    touched,
    errors,
    values,
    setFieldTouched,
    setFieldValue
  };
  const getRequests = async () => {
    const regions = await RegionService.getAll();
    setRegions(regions);
  };
  useEffect(() => {
    getRequests();
  }, []);

  return (
    <Card className={classes.card}>
      <CardHeader title={title} className={classes.cardTitle} />
      <CardContent className={classes.cardContent}>
        {values ? (
          <React.Fragment>
            {getInputField({
              ...fieldProps,
              name: `code`,
              label: `Código`,
              required: true,
              changeHandler: value =>
                maximumSubString(COMMUNE_MAX_LENGTH_CODE)(allowNumeric(value)),

              formControlClass: classes.fullWidth
            })}
            {getInputField({
              ...fieldProps,
              name: `nameEFX`,
              label: `Comuna EFX`,
              required: true,
              changeHandler: maximumSubString(COMMUNE_EFX_MAX_LENGTH_NAME),
              formControlClass: classes.fullWidth
            })}
            {getInputField({
              ...fieldProps,
              name: `name`,
              label: `Nombre`,
              required: true,
              changeHandler: maximumSubString(COMMUNE_MAX_LENGTH_NAME),
              formControlClass: classes.fullWidth
            })}
            {getInputField({
              ...fieldProps,
              name: `province`,
              label: 'Provincia',
              required: true,
              changeHandler: maximumSubString(COMMUNE_LENGTH_PROVINCE),
              formControlClass: classes.fullWidth
            })}
            {getSelectField({
              ...fieldProps,
              name: `region`,
              label: 'Región *',
              required: true,
              options: regions,
              onMenuClose: () => {
                setFieldTouched('region');
              },
              inputChange: (newValue, actionMeta) =>
                maximumSubString(REGION_MAX_LENGTH_NAME)(newValue),
              formControlClass: classes.fullWidth
            })}
          </React.Fragment>
        ) : (
          ''
        )}
      </CardContent>
    </Card>
  );
};

form.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(form);
